export const horseVetMenu = [
    {title: "Товары", url: "/horsevet/tovars"},
    {title: "Заявки", url: "/horsevet/requests"},
]